import { createGlobalStyle } from 'styled-components';

export const TwitterStyle = createGlobalStyle`
  body .twitter-tweet {
    margin-left: auto;
    margin-right: auto;
  }
`;
